import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

@Component({
  selector: 'page-user-register',
  templateUrl: 'user-register.html'
})
export class UserRegisterPage {

  event: any;
  constructor(public navCtrl: NavController, public params: NavParams) {
    this.event = this.params.get('event');
  }

}
// end file



// WEBPACK FOOTER //
// ./src/pages/user-register/user-register.ts